export const storageKeys = {
	ACCESS_TOKEN: 'access_token',
	REFRESH_TOKEN: 'refresh_token',
	USER_NAME: 'user_name',
	I18NEXTLNG: 'i18nextLng',
	CONTRACT_BULK_ENABLED: 'contract_bulk_enabled',
	REMEMBER_ME: 'remember_me'
};
